module.exports = __webpack_public_path__ + "images/category_lp/jewel/new/mainView-pc_d26f1c2a9ba2f3f2ed55ab450484ed02.png";